import SurveyEditStore, { modifyComparisonDetails, ModifyComparisonDetails } from "../../stores/SurveyEditStore";
import { useStore } from "effector-react";

import { PersonComparison, PersonComparisonOperator, PersonQuestion } from "reliance-private-survey-schema/dist/API";

import { useCallback } from "react";

import * as _ from "lodash";

function PersonComparisonEdit(props: { comp: PersonComparison; index: number; condIndex: number }) {
    const survey_edit = useStore(SurveyEditStore);

    const q = survey_edit.allQuestions[props.comp.questionId!] as unknown as PersonQuestion;

    const handleChange = useCallback(
        (fieldName: string, fieldValue: string) => {
            var payload: ModifyComparisonDetails = {
                comp: _.cloneDeep(props.comp),
                index: props.index,
                condIndex: props.condIndex,
                fieldName: fieldName,
                fieldValue: fieldValue,
            };
            modifyComparisonDetails(payload);
        },
        [props]
    );

    return (
        <>
            {q && (
                <div>
                    <div>
                        <b>Field:</b>
                        <span className="px-3">
                            <select
                                id="questionField"
                                name="questionField"
                                className="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                value={props.comp.questionField ?? ""}
                                onChange={(e) => handleChange(e.target.name!, e.target.value!)}
                            >
                                <option value=""></option>
                                {["gender"].map((k, idx) => (
                                    <option key={k} value={k}>
                                        {k}
                                    </option>
                                ))}
                            </select>
                        </span>
                    </div>
                    <div>
                        <b>Operator:</b>
                        <span className="px-3">
                            <select
                                id="personComparisonOperator"
                                name="personComparisonOperator"
                                className="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                value={props.comp.personComparisonOperator}
                                onChange={(e) => handleChange(e.target.name!, e.target.value!)}
                            >
                                <option value=""></option>
                                {Object.keys(PersonComparisonOperator).map((k) => (
                                    <option key={k} value={k}>
                                        {k}
                                    </option>
                                ))}
                            </select>
                        </span>
                    </div>
                    {["EQUALS", "NOT_EQUALS"].includes(props.comp.personComparisonOperator ?? "") && (
                        <>
                            <div>
                                <b>Value:</b>
                                <span className="px-3">
                                    <select
                                        id="value"
                                        name="value"
                                        className="max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                                        value={props.comp.value ?? ""}
                                        onChange={(e) => handleChange(e.target.name!, e.target.value!)}
                                    >
                                        <option value=""></option>
                                        {["Male", "Female"].map((k) => (
                                            <option key={k} value={k.charAt(0)}>
                                                {k}
                                            </option>
                                        ))}
                                    </select>
                                </span>
                            </div>
                        </>
                    )}
                </div>
            )}
        </>
    );
}

export default PersonComparisonEdit;
